import { gsap, ScrollTrigger} from '../layout';
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function(){
	if (window.innerWidth > 767) {
		const lists = gsap.utils.toArray(".challenge__list");
		let currentIndex = 0;
		let isHovering = false;
	
		// GSAP Infinite Loop Timeline
		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: ".challenge",
				start: "-300px top",
				end: "bottom center",
			},
			repeat: -1,
			defaults: { ease: "none", duration: 1 },
			onStart: () => {
				lists[0].classList.add('active');
			},
			onUpdate: () => {
				const index = Math.floor(tl.progress() * lists.length) % lists.length;
				if (!isHovering && currentIndex !== index) {
					lists.forEach(item => item.classList.remove('active'));
					lists[index].classList.add('active');
					currentIndex = index;
				}
			},
			onComplete: () => {
				lists[lists.length - 1].classList.remove('active');
			}
		});
	
		// Animate list items in an infinite loop
		lists.forEach((list, index) => {
			tl.to(list, { opacity: 1, duration: 7 }, index);
		});
	
		// Hover events to pause & resume animation
		lists.forEach((list, index) => {
			list.addEventListener("mouseenter", () => {
				isHovering = true;
				tl.pause();
				lists.forEach(item => item.classList.remove('active'));
				list.classList.add('active');
			});
	
			list.addEventListener("mouseleave", () => {
				isHovering = false;
				lists.forEach(item => item.classList.remove('active'));
				if (currentIndex >= 0) {
					lists[currentIndex].classList.add('active');
				}
				tl.play();
			});
		});
	}	
});